import React from 'react';
import FooterLinkStyles from './FooterLink.module.scss';

type Props = {
  title: string;
  link: string;
};

export const FooterLink: React.FC<Props> = ({ title, link }) => {
  return (
    <a href={link} className={FooterLinkStyles.footer_link}>
      {title}
    </a>
  );
};
